import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import profile from 'src/store/profile';
import api from 'src/utils/api';
import { useNavigate } from 'react-router-dom';
import { Alert, Container, Card, Stack, Box, CircularProgress } from '@mui/material';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';

export default function CalendarPage() {
  const [groups, setGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  const handleEventClick = ({ event }) => {
    // Якщо це заміна, беремо real_group_id, інакше беремо звичайний id
    const realId = event.extendedProps.real_group_id || event.id;
    navigate('/teacher/user', { state: { ...event.extendedProps, id: realId } })
  }

  useEffect(() => {
    api.get(`sgroup-api?filter[teacher_id]=${profile.data.id}`)
      .then(
        (result) => {
          const calendarEvents = result.map((item) => {
            if (item.is_substitution) {
              return {
                ...item,
                id: `sub-${item.id}-${item.substitution_date}`, // Унікальний ID для FullCalendar
                real_group_id: item.id, // Зберігаємо оригінальний ID групи
                title: `${item.name} (Заміна)`,
                start: item.substitution_date, 
                backgroundColor: '#ff9800', 
                borderColor: '#f57c00',
                textColor: '#fff'
              };
            }

            return {
              ...item,
              title: item.name,
              startRecur: item.date_start,
              endRecur: item.date_end,
              daysOfWeek: [item.first_day, item.second_day]
            };
          });
          
          setGroups(calendarEvents);
          setIsLoading(false);
        },
        () => {
          setIsLoading(false);
        }
      )
  }, [])

  return (
    <>
      <Helmet>
        <title> Розклад | Lala English </title>
      </Helmet>

      <Alert severity="error" sx={{ mb: 5, pl: 3 }}>Розклад занять усіх ваших груп студентів.</Alert>
      <Container>
        <Card>
          <Stack spacing={2} sx={{ p: 3 }}>
            {isLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                <CircularProgress />
              </Box>
            ) : (
              <FullCalendar
                plugins={[dayGridPlugin]}
                eventClick={handleEventClick}
                initialView="dayGridMonth"
                weekends
                events={groups}
                locale='uk'
                buttonText={{
                  today: 'Сьогодні'
                }}
              />
            )}
          </Stack>
        </Card>
      </Container>
    </>
  );
}